import { inject, Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import {
  AssistanceCareLog,
  AssistanceCareLogCreate,
  AssistanceCareLogQuery,
} from '../../models/assistance-care-log.model'
import { FeathersService } from '../feathers.service'

@Injectable({
  providedIn: 'root',
})
export class AssistanceCareLogService {
  private readonly feathers = inject(FeathersService)

  find(query: AssistanceCareLogQuery): Observable<AssistanceCareLog[]> {
    if (query.assignmentIds.length === 0) {
      return of([])
    }
    return this.feathers.find(AssistanceCareLog, {
      assignmentId: { $in: [...query.assignmentIds] },
    })
  }

  create(log: AssistanceCareLogCreate): Promise<AssistanceCareLog> {
    return this.feathers.createWithFactory(AssistanceCareLog, log as Partial<AssistanceCareLog>)
  }

  patch(
    id: number,
    changes: Pick<AssistanceCareLog, 'careDurationMinutes'>,
  ): Promise<AssistanceCareLog> {
    return this.feathers.patchWithFactory(AssistanceCareLog, {
      id,
      ...changes,
    } as Partial<AssistanceCareLog>)
  }

  remove(id: number): Promise<void> {
    return this.feathers.removeById(AssistanceCareLog.serviceName, id).then(() => undefined)
  }
}
